<template>
    <div class="LearnCount">
        <div class="countWrap">
            <div class="topWrap">
                <h4>年份筛选</h4>
                <div class="yearBox">
                    <span :class="light==0?'light':''" @click="changeSort(0)">全部</span>
                    <span v-for="(item, index) in yearList" :key="item" :class="{'light': light === index + 1}" @click="changeSort(index, item)">{{item}}</span>
                </div>
            </div>
            <!-- 移动端年份筛选 -->
            <div class="dropdown">
                <!-- <el-dropdown @command="handleCommand" trigger="click"> -->
                <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{ dropdownVal }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="false">全部</el-dropdown-item>
                        <el-dropdown-item v-for="item in yearList" :key="item" :command="item">{{item}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <!-- 列表 -->
            <ul class="listTitle">
                <li class="pc_listTitle">
                    <span>课程名称</span>
                    <span>实际学习时长</span>
                    <span>实得学分</span>
                </li>
                <li class="mobile_listTitle">
                    <span>课程名称 | 实际学习时长</span>
                    <span>实得学分</span>
                </li>
            </ul>
            <ul class="listWrap">
                <li v-for="(item,index) in StudyStatList" :key="index">
                    <router-link :to="{path:'/classDetial', query:{courseId:item.CourseID}}" @click.native="saveID(item.CourseID)">
                        <div class="title-time">
                            <span>{{item.Title}}</span>
                            <span>{{item.RealSec | formatData}}</span>
                        </div>
                        <span class="xf_Num">{{item.RealScore}}</span>
                    </router-link>
                </li>
            </ul>
            <!-- 分页器 -->
            <div class="page"><Pagination :total='totalPage' :page="page" :pageSize = 'pagesize' @currentPage="currentPage"></Pagination></div>
        </div>
        <!-- 移动端 -->
        <p class="moreCourse" v-if="isShowMore" @click="getMore">查看更多</p>
    </div>
</template>

<script>
import Pagination from '../../components/Pagination'
export default {
    data() {
        return {
            light: 0,  // 是否被选中
            year: 2021,
            all: true,
            dropdownVal:'全部',  // 下拉框值
            totalPage:0,  // 总页数
            page:1,  // 页数
            pagesize:9,  // 多少条数据
            StudyStatList:[],  // 学习统计列表
            isShowMore:true,  // 移动端的查看更多
			yearList: []
        }
    },
    mounted(){
		// 获取年份列表
		this.yearList = this.getYearsFn()
		// 获取学习统计
        this.getStudyStat();
    },
    methods: {
		// 获取年份
		getYearsFn() {
			let nowYear = new Date().getFullYear()
			let list = []
			for(let i = 2020; i <= nowYear; i ++) {
				list.push(i)
			}
			return list.reverse()
		},
        // 获取学习统计
        getStudyStat(type){
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = this.all ? {
                "TimeStamp":timestamp,
                "PageSize":this.pagesize,
                "CurPage":this.page
            } : {
                "TimeStamp":timestamp,
                "PageSize":this.pagesize,
                "CurPage":this.page,
                "Query": [
                    {"Item":"Year","Value":this.year}
                ]
            };
            this.$axios.post(Const_Api_Root+'api/Member/MyCourseStatistics',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    // 总数
                    this.totalPage = res.data.Data.Total;
                    if(type == 'more'){
                        // 移动端的操作
                        this.StudyStatList = this.StudyStatList.concat(res.data.Data.Rows);
                    }else{
                        // 列表
                        this.StudyStatList = res.data.Data.Rows;
                    }
                    
                    // 是否显示查看更多
                    if(this.totalPage != this.StudyStatList.length){
                        this.isShowMore = true;
                    }else{
                        this.isShowMore = false;
                    }
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 移动端的获取更多
        getMore(){
            this.page++;
            this.getStudyStat('more');
        },
        // 分页器
        currentPage(index){
            this.page = index;
            this.getStudyStat();
        },
        // 保存id
        saveID(id){
            sessionStorage.setItem('courseID',id);
            sessionStorage.setItem('returnPage','LearnCount');
        },
        // pc年份选择
        changeSort(n, y) {
            this.light = n + 1;
            this.page = 1;
            if(y) {
                this.year = y;
                this.all = false;
            }else {
                this.all = true;
            }
            this.getStudyStat();
        },
        // 下拉框
        handleCommand(command) {
            if(!command) {
               this.all = true;
            }else {
               this.year = command;
               this.all = false;
            }
            this.dropdownVal = command;
            this.getStudyStat();
        }
    },
    filters: {
        // 格式化时间
        formatData:(value) => {
            let result = parseInt(value)
            let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
            let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
            let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
            value = h+':'+m+':'+s;
            return value;
        }
    },
    components: {
        Pagination
    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px) {
    .page{
        display: none;
    }
    .listTitle .pc_listTitle{
        display: none;
    }
    .LearnCount{
        width: 100%;
        background-color: #fafafa;
        .countWrap{
            background-color: #fff;
            overflow: hidden;
        }
        .topWrap{
            display: none;
        }
        .listTitle li{
            justify-content: space-between;
            padding-bottom: 10px;
            border-bottom: 2px solid #fafafa;
        }
        ul li,li a{
            display: flex;
            align-items: center;
            .xf_Num{
                width: 10%;
                color: #19191a;
                text-align: right;
            }
            .title-time{
                width: 90%;
                span:first-child{
                    font-size: 14px;
                    color: #19191A;
                    margin: 12px 0 7px;
                    overflow: hidden; 
                    text-overflow: ellipsis;
                    white-space: nowrap; 
                }
                span:last-child{
                    font-size: 12px;
                    color: rgba(25,25,26,0.80);
                    margin-bottom: 12px;
                }
            }
            span{
                display: block;
            }
        }
        .listTitle{
            width: 100%;
            span{
                font-size: 12px;
                color: rgba(25,25,26,0.80);
            }
        }
        .listWrap{
            width: 100%;
            li{
                border-bottom: 2px solid #fafafa;
            }
            a{
                width: 100%;
                font-size: 14px;
                color: rgba(25,25,26,0.80);
            }
        }
    }
    // 查看更多
    .moreCourse{
        font-size: 14px;
        color: #0061FE;
        text-align: center;
        font-weight: bold;
        padding: 20px 0;
        background-color: #fff;
    }
    // 下拉框
    .dropdown{
        display: flex;
        justify-content: flex-end;
        margin: 33px 0 40px;
    }
}
@media screen and (min-width: 1445px) {
    .listTitle .mobile_listTitle,.dropdown,.moreCourse{
        display: none;
    }
    .LearnCount{
        width: 100%;
		min-height: 800px;
        background-color: #fafafa;
        .countWrap{
            background-color: #fff;
            width: 1200px;
            margin: 0 auto;
            overflow: hidden;
            padding: 0 60px 0 56px;
        }
        .topWrap{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 60px 0 32px;
            h4{
                font-size: 20px;
            }
            span{
                font-size: 16px;
                color: rgba(25,25,26,0.80);
                line-height: 16px;
                margin-left: 30px;
                cursor: pointer;
            }
            .light{
                color: #19191A;
                font-weight: bold;
            }
        }
        .page{
            margin: 40px 0;
        }
    }
    ul li,li a{
        display: flex;
        align-items: center;
        .title-time{
            display: flex;
            align-items: center;
            width: 80%;
            span{
                &:first-child{
                    width: 80%;
                    overflow: hidden; 
                    text-overflow: ellipsis;
                    white-space: nowrap; 
                    text-align: left;
                }
                &:last-child{
                    width: 20%;
                }
            }
        }
        .xf_Num{
            width: 20%;
            margin-right: 61px;
        }
        span{
            text-align: right;
        }
    }
    .listTitle{
        width: 100%;
        margin-bottom: 32px;
        span{
            font-size: 12px;
            display: block;
            width: 20%;
            text-align: right;
            font-weight: bold;
            &:first-child{
                width: 60%;
                text-align: left;
                overflow: hidden; 
                text-overflow: ellipsis;
                white-space: nowrap; 
            }
            &:last-child{
                margin-right: 61px;
            }
        }
    }
    .listWrap{
        width: 100%;
        min-height: 468px;
        li{
            border-bottom: 2px solid #fafafa;
        }
        a{
            width: 100%;
            line-height: 50px;
            font-size: 14px;
            color: rgba(25,25,26,0.80);
        }
    }
}
@media screen and (min-width: 1029px) and (max-width: 1440px){
    .listTitle .mobile_listTitle,.dropdown,.moreCourse{
        display: none;
    }
    .LearnCount{
        width: 100%;
		min-height: 600px;
        background-color: #fafafa;
        .countWrap{
            background-color: #fff;
            width: 1100px;
            margin: 0 auto;
            overflow: hidden;
            padding: 0 60px 0 56px;
        }
        .topWrap{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 60px 0 32px;
            h4{
                font-size: 20px;
            }
            span{
                font-size: 16px;
                color: rgba(25,25,26,0.80);
                line-height: 16px;
                margin-left: 30px;
                cursor: pointer;
            }
            .light{
                color: #19191A;
                font-weight: bold;
            }
        }
        .page{
            margin: 40px 0;
        }
    }
    ul li,li a{
        display: flex;
        align-items: center;
        .title-time{
            display: flex;
            align-items: center;
            width: 80%;
            span{
                &:first-child{
                    width: 80%;
                    overflow: hidden; 
                    text-overflow: ellipsis;
                    white-space: nowrap; 
                    text-align: left;
                }
                &:last-child{
                    width: 20%;
                }
            }
        }
        .xf_Num{
            width: 20%;
            margin-right: 61px;
        }
        span{
            text-align: right;
        }
    }
    .listTitle{
        width: 100%;
        margin-bottom: 32px;
        span{
            font-size: 12px;
            display: block;
            width: 20%;
            text-align: right;
            font-weight: bold;
            &:first-child{
                width: 60%;
                text-align: left;
                overflow: hidden; 
                text-overflow: ellipsis;
                white-space: nowrap; 
            }
            &:last-child{
                margin-right: 61px;
            }
        }
    }
    .listWrap{
        width: 100%;
        min-height: 468px;
        li{
            border-bottom: 2px solid #fafafa;
        }
        a{
            width: 100%;
            line-height: 50px;
            font-size: 14px;
            color: rgba(25,25,26,0.80);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenter/LearnCount.vue